import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import type { PropertyGroupResponse } from '~/http/backoffice/property-groups/types'

export class PropertyGroupsAPI extends Http {
  getList = (): Promise<PropertyGroupResponse> => {
    return this.callAuthAPI<null, PropertyGroupResponse>(
      HttpMethod.GET,
      { path: APIPaths.PROPERTY_GROUPS_OPTIONS },
      null,
    )
  }
}
